<template>
  <v-tooltip top :disabled="disabledTooltip">
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        :loading="computedLoading"
        :color="computedStatus.color"
        @click.stop="$emit('click', $event)"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon :color="computedStatus.color">{{ computedStatus.icon }}</v-icon>
        <template #loader>
          <v-progress-circular
            v-bind="attrs"
            rotate="-90"
            size="24"
            v-on="on"
            :value="progress"
            :indeterminate="!progress"
          ></v-progress-circular>
        </template>
      </v-btn>
    </template>
    <span>{{ computedTooltip }}</span>
  </v-tooltip>
</template>

<script>
const states = {
  NO_JOB: {
    tooltip: "Press to run",
    icon: "directions_run",
    color: "grey",
    action: null,
  },
  NOT_STARTED: {
    tooltip: "Press to cancel",
    icon: "hourglass_empty",
    color: "warning",
    action: null,
  },
  COMPLETE: {
    tooltip: "Press to re-run",
    icon: "check_circle",
    color: "success",
    action: null,
  },
  COMPLETE_WITH_WARNINGS: {
    tooltip: "Finished with warnings. Click for details.",
    icon: "check_circle",
    color: "warning",
    action: null,
  },
  DONE: {
    tooltip: "Done",
    icon: "check_circle",
    color: "success",
  },
  IN_PROGRESS: {
    tooltip: "In Progress",
    icon: null,
    color: "primary",
    action: null,
  },
  ERROR: {
    tooltip: "Had errors",
    icon: "error",
    color: "error",
    action: null,
  },
};
export default {
  name: "JobIndicator",
  components: {},
  props: {
    status: {
      required: false,
      default: "NO_JOB",
    },
    progress: {
      type: Number,
      required: false,
      default: null,
    },
    error: {
      type: String,
      required: false,
      default: () => "",
    },
    disabledTooltip: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      reRunDialogOpen: false,
    };
  },
  computed: {
    computedStatus() {
      if (this.status == null) return states.NO_JOB;
      return states[this.status];
    },
    computedLoading() {
      return this.status === "IN_PROGRESS";
    },
    computedTooltip() {
      return this.error ? this.error : this.computedStatus.tooltip;
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>
